import { PagePerformanceLifecycle } from '@/lib/page-performance/PagePerformanceLifecycle'

export class DefaultPagePerformanceLifecycle extends PagePerformanceLifecycle {
  constructor(routeKey: string) {
    super(`default:${routeKey}`, 'default')
  }

  markRenderComplete(): void {
    this.setInteractive()
  }
}
